import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'

export default {
  name: 'proposal',
  components: {
    SharedHeader,
    SharedFooter
  },
  computed: {
    env () {
      return this.$store.getters.env
    },
    user () {
      return this.$store.getters.user
    },
    file () {
      return `${this.env.S3}/enterprise/${this.smartthon.enterpriseId}/smartthon/${this.smartthon.smartthonId}/suggestion/${this.$route.params.studentId}/${this.suggestion.fileName}`
    }
  },
  data () {
    return {
      title: '',
      student: {},
      smartthon: {},
      grade: {},
      suggestion: {},
      loading: true,
      share: '',
      isCopied: false,
      isModal: false,
      modalInfo: {},
      updating: false,
      error: {
        flag: false,
        message: ''
      }
    }
  },
  mounted () {
    let pathParams = {
      enterpriseId: this.user.enterpriseId,
      smartthonId: this.$route.params.smartthonId,
      studentId: this.$route.params.studentId
    }

    let additionalParams = {
      queryParams: {
        type: 'report'
      }
    }

    this.$apig.get(this.$store.getters.api.SUGGESTION, pathParams, additionalParams, {})
      .then(response => {
        this.title = response.data.suggestion.title
        this.student = response.data.student
        this.smartthon = response.data.smartthon
        this.grade = response.data.grade
        this.suggestion = response.data.suggestion
        this.share = `${this.env.DOMAIN}/review/${this.user.enterpriseId}/${this.$route.params.smartthonId}/${this.$route.params.studentId}`
        this.loading = false
      })
  },
  methods: {
    onCopy () {
      this.isCopied = true
    },
    studentAvatar (item) {
      return `${this.env.S3}/student/avatar/${item.avatarId}.png`
    },
    getIcon (i, score) {
      if (i <= Math.floor(score)) return 'star'
      else if (i > Math.floor(score) && i <= Math.round(score)) return 'star-half-alt'
      else return 'star'
    },
    openModal () {
      this.isModal = true
    },
    setPrize () {
      this.updating = true

      let pathParams = {
        enterpriseId: this.user.enterpriseId,
        smartthonId: this.$route.params.smartthonId,
        studentId: this.$route.params.studentId
      }

      let additionalParams = {
        queryParams: {
          type: 'prize'
        }
      }

      this.$apig.patch(this.$store.getters.api.SUGGESTION, pathParams, additionalParams, {})
        .then(response => {
          this.student.status = '4'
          this.updating = false
          this.isModal = false
          window.scrollTo(0, 0)
        })
        .catch(err => {
          console.log(err)
          this.error = {
            flag: true,
            message: err.response.data.message
          }
          this.updating = false
        })
    },
    resetModal () {
      this.error = {
        flag: false,
        message: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/report/detail/proposal/proposal.js